import { PlusIcon, TerminalWindowIcon, XIcon } from '@phosphor-icons/react';

import classNames from '@/utils/classnames';

export interface TerminalTabState {
  key: string;
  label: string;
  ptySessionId: string | null;
}

interface SessionStripProps {
  tabs: TerminalTabState[];
  activeKey: string;
  onSelect: (key: string) => void;
  onAdd: () => void;
  onClose: (key: string) => void;
}

export function SessionStrip({ tabs, activeKey, onSelect, onAdd, onClose }: SessionStripProps) {
  return (
    <div className="flex h-8.5 shrink-0 items-center gap-1 border-b border-line-subtle bg-surface-1 px-1.5">
      {tabs.map((tab) => (
        <div
          key={tab.key}
          className={classNames(
            'group flex h-6.5 shrink-0 cursor-pointer items-center gap-1.5 rounded-md px-2.5 text-xs',
            activeKey === tab.key
              ? 'bg-surface-3 text-fg'
              : 'text-fg-tertiary hover:bg-surface-2 hover:text-fg-secondary',
          )}
          onClick={() => onSelect(tab.key)}
        >
          <TerminalWindowIcon size={13} />
          <span className="font-mono">{tab.label}</span>
          {tabs.length > 1 && (
            <button
              type="button"
              aria-label="Close terminal"
              onClick={(e) => {
                e.stopPropagation();
                onClose(tab.key);
              }}
              className="rounded p-0.5 opacity-0 hover:bg-surface-4 group-hover:opacity-100"
            >
              <XIcon size={11} />
            </button>
          )}
        </div>
      ))}
      <button
        type="button"
        aria-label="New terminal"
        onClick={onAdd}
        className="flex size-6 shrink-0 items-center justify-center rounded-md text-fg-tertiary hover:bg-surface-2 hover:text-fg-secondary"
      >
        <PlusIcon size={13} />
      </button>
    </div>
  );
}
